import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Quotation } from '../_models/quotation';
import { environment } from './../../../environments/environment';

@Injectable()
export class QuotationService {
  private apiBaseUrl = environment.apiBaseUrl;

  constructor(private http: HttpClient) {}

  getQuotations(): Observable<Quotation[]> {
    return this.http
      .get<Quotation[]>(this.apiBaseUrl + 'api/private/v1/documentQuotations')
      .pipe(map((response) => response));
  }

  getQuotation(id: number): Observable<Quotation> {
    return this.http
      .get<Quotation>(this.apiBaseUrl + 'api/private/v1/documentQuotations/' + id)
      .pipe(map((response) => response));
  }
}
